import TableCell from "@mui/material/TableCell";
import { middleCellSx, questionTypeSx } from "./tableStyles";

const cellStyles = [
  { sx: { ...questionTypeSx, borderLeft: 1 } },
  { sx: middleCellSx },
  { sx: middleCellSx },
  { sx: middleCellSx },
];

const EmptyCells = () => {
  return (
    <>
      {cellStyles.map((cell, index) => (
        <TableCell
          key={index}
          sx={{
            ...cell.sx,
            borderRight: 1,
            borderColor: "var(--color-table-header)",
          }}
        />
      ))}
    </>
  );
};

export default EmptyCells;
